import request from '@/utils/request.js';

// 获取闪运个人版订单信息
export function apigetAppOrderInfo(params) { 
    return request({
        url:'/logistic/app/api/ownOrder/viewOrderByAccessCode',
        method:'GET',
        params
    })
 }

 // 获取闪运企业版订单信息
 export function apigetVipAppOrderInfo(params) { 
    return request({
        url:'/logistic/vipapp/api/vipTransportOwnOrder/viewOrderByAccessCode',
        method:'GET',
        params
    })
 }

 // 获取跳转链接
export function apigetLink(params) { 
    return request({
        url:'/auth/wechat/applet/getAppletsUrlLinkToPay',
        method:'GET',
        params
    })
 }

  // 获取跳转链接
export function apigetWeixinLink(params) { 
    return request({
        url:'/auth/wechat/applet/api/getAppletsUrlToShareCodeH5',
        method:'GET',
        params
    })
 }